import Dialog from '@/js/components/Dialog'
import DialogForm from '@/js/components/DialogForm'

export default class DialogForgotPassword extends DialogForm {
    name = 'forgot-password'

    onSubmitSuccess(response) {
        Dialog.show('forgot-password-mail-success', {
            message: response.message,
        })
    }

    afterShow() {
        this.refs.form.querySelector('input[name="email"]').focus()
    }
}
